import { render, staticRenderFns } from "./files_menu.vue?vue&type=template&id=6b6fefc6&scoped=true"
import script from "./files_menu.vue?vue&type=script&lang=js"
export * from "./files_menu.vue?vue&type=script&lang=js"
import style0 from "./files_menu.vue?vue&type=style&index=0&id=6b6fefc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6fefc6",
  null
  
)

export default component.exports